import {useInjection} from "inversify-react";
import {useCallback, useEffect, useState} from "react";
import ApiService from "../../services/apiService";
import {BasketApi, BasketDto} from "../../api";
import BasketsList from "./basketList";

export default function BasketsListContainer() {
    const apiService = useInjection(ApiService);
    const [baskets, setBaskets] = useState<BasketDto[] | null>();

    const refreshBasketsList = useCallback(async () => {
        try {
            const baskets = await apiService.getApi(BasketApi).apiBasketGetAllBasketsGet();
            setBaskets(baskets.data);
        } catch (e: any) {
            console.log(e.response.data);
        }
    }, [apiService]);

    const onDeleteClicked = async (id: string) => {
        try {
            await apiService.getApi(BasketApi).apiBasketDeleteBasketIdDelete(id);
        } catch (e: any) {
            console.log(e);
        }
    }

    useEffect(() => {
        refreshBasketsList();
    }, [refreshBasketsList]);

    return <>
        <h1>Koszyki</h1>
        <BasketsList
            data={baskets || null}
            onDeleteClicked={onDeleteClicked}
        />
    </>
}
